import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["children", "timeToImpression", "options", "sx", "onCreateImpression"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box } from '@hub/box';
import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { jsx as _jsx } from "react/jsx-runtime";

const ImpressionTracker = _ref => {
  let {
    children,
    timeToImpression,
    options,
    sx,
    onCreateImpression
  } = _ref,
      extraProps = _objectWithoutProperties(_ref, _excluded);

  const {
    ref,
    inView,
    entry
  } = useInView(_objectSpread({}, options));
  const {
    0: impression,
    1: setImpression
  } = useState(0);
  useEffect(() => {
    const timer = inView && !impression ? setTimeout(() => {
      setImpression(count => count + 1);
      onCreateImpression === null || onCreateImpression === void 0 ? void 0 : onCreateImpression(entry);
    }, timeToImpression) : null;
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    }; // TODO check if we can add missing deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);
  return /*#__PURE__*/_jsx(Box, {
    sx: sx,
    ref: ref,
    "data-id": "impression-tracker_index_ImpressionTracker_Box",
    children: /*#__PURE__*/React.cloneElement(children, _objectSpread(_objectSpread({}, children.props), extraProps))
  });
};

export default ImpressionTracker;